import { render, staticRenderFns } from "./StatisticsProfessorMarks.vue?vue&type=template&id=3c795661"
import script from "./StatisticsProfessorMarks.vue?vue&type=script&lang=js"
export * from "./StatisticsProfessorMarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports